<h1 i18n>Inloggen</h1>

<p i18n>Login met het formulier hieronder.</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="mb-3">
        <label for="username" class="form-label" i18n>Gebruikersnaam</label>
        <input type="text" id="username" autocomplete="username" class="form-control" [class.is-invalid]="
                form.controls.username.touched && form.controls.username.invalid
            " [formControl]="form.controls.username" />
        @for (error of usernameErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div class="mb-3">
        <label for="password" class="form-label" i18n>Wachtwoord</label>
        <input type="password" id="password" autocomplete="current-password" class="form-control"
            [formControl]="form.controls.password" [class.is-invalid]="
                form.controls.password.touched && form.controls.password.invalid
            " />
        @for (error of passwordErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    @for (error of formErrors$ | async; track $index) {
    <p class="invalid-feedback always-block">
        {{ error }}
    </p>
    }
    <div class="mb-3">
        <button type="submit" class="btn btn-primary mt-3">
            <span i18n>Inloggen</span>
            @if (loading$ | async) {
            <div class="spinner-border spinner-border-sm ms-1" role="status">
                <span class="visually-hidden" i18n>Inloggen...</span>
            </div>
            }
        </button>
    </div>
</form>

<div>
    <a [routerLink]="['/password-forgotten']" i18n> Wachtwoord vergeten? </a>
</div>
